import { IPatientEnrollmentProps } from './types';
import { Section } from '../section/section';
import { ISectionProps } from '../section/interfaces';

export const PatientEnrollmentSection = (props: ISectionProps<IPatientEnrollmentProps>) => Section<IPatientEnrollmentProps>(props);
